import '../../styles/speaker.css';
import logo from '../../assets/images/Q3logotext.png';
import marcello from "../../assets/images/speakers/marcello.jpeg";

function Marcello() {
  return (
    <>
    <div class="header">
      <div class="header-content">
        <div class="left">
          <div class="header-box">
            <h1 className="title">Q<sup>3</sup> Initiative: QREATE @ UMD</h1>
          </div>
          <p>September 12, 2025 - September 13, 2025</p>
          <p>University of Maryland, College Park</p>
          <p>Stamp Student Union: Hoff Theatre</p>
        </div>
        <div className="right">
          <img src={logo} className="logo" alt="Q^3 Logo" />
        </div>
      </div>
    </div>
    <div className="speaker-box">
      <div className="speaker-photo">
         <img src={marcello} alt="Marcello Silva" className="speakerspic"/>
      </div>
      <div className="speaker-content">
      <h1>Marcello Silva</h1>
      <h2>Classical Pianist & Undergraduate at UMD</h2>
    </div>  
    </div>
    <div className="speaker-content">
      <p className="p">
        Marcello Silva is a classical pianist who is pursuing a double degree in Bachelor of Music in Piano Performance and a Bachelor of Science in Neuroscience. He believes there is great opportunity for the potential for music to impact the brain and cognition, and his two passions has led him to exploring ways of connecting the Arts with Sciences. He has studied with teachers from the Juliard School of Music, the Moscow Conservatory and others. And now has the opportunity to be apart of the Dr. Tsong studio at the University of Maryland.He has participated in U.S. and international piano performances and competitions where he received several awards and was able to perform at important venues around the world. 

      </p>
    </div>
    </>
  );
}

export default Marcello;